var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 941,
    viewBox: "0 0 800 941",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M800 762.153L60.7722 938.492L0 730.273L739.228 553.934L800 762.153Z",
    fill: "#FCA17D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316.812 546.96H226.152L0 3.99634H235.119L380.573 382.577",
    fill: "#DD7373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M525.031 4.99632L380.573 383.577L316.812 546.964H533.998L760.149 4H525.031V4.99632Z",
    fill: "#DD7373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M316.812 546.96H226.152L0 3.99634H235.119L380.573 382.577",
    fill: "#0D0628"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dab4e5228f0a6b088bcda3ddaaf09dfd.svg";
export { ForwardRef as ReactComponent };